import React, { Component } from 'react';
import './IconButton.css';

class IconButton extends Component {
    render() {
        return (
            <li onMouseDown={this.props.iconOnClick} onClick={this.props.iconOnClick}  className="IconButton">
                <img className={"icon " + this.props.className} alt={this.props.icon.id} src={process.env.PUBLIC_URL + '/icons/' + this.props.icon.image} />
                <div className="text">
                    {this.props.icon.text}
                </div>
            </li>
        );
    }
}

export default IconButton;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/DrawerContainer/components/IconButton/index.js